import { Component, OnInit, ViewChild } from '@angular/core';
import { Location } from '@angular/common';

import { STATIC_VALUE } from '../../shared/configuration/static.value';
import { NceService } from '../services/nce.service';
import { PopupService } from '../../shared/services/pop-up.service';
import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { StorageService } from '../../shared/services/storage.service';
import { FileService } from '../../shared/services/file.service';
import { LayoutService } from '../../shared/services/layout.service';
import { CONFIGURATION } from '../../shared/configuration/configuration';

@Component({
    selector: 'apply-for-final-approval',
    templateUrl: 'apply-for-final-approval.component.html'
})

export class NceApplyForFinalApprovalComponent implements OnInit{
    @ViewChild('fileInput') vFileInput;
    bottom_contractor_name : string = '';
    bottom_contractor_designation : string = '';
    details : string = '';
    dates : any[] = [
        {},
        {completed: null, date: null},
        {completed: null, date: null},
        {completed: null, date: null},
        {completed: null, date: null},
        {completed: null, date: null},
        {completed: null, date: null},
        {completed: null, date: null}
    ];
    file : any = null;

    constructor(
        private _nceService: NceService,
        private _location: Location,
        private _pageNavigationService: PageNavigationService,
        private _storageService: StorageService,
        private _popupService: PopupService,
        private _fileService: FileService,
        private _layoutService: LayoutService,
    ) { }


    ngOnInit() {
        this._layoutService.setCurrentPage('nce-apply-for-final-approval');
        this._layoutService.setNCEFlow('nce-apply-for-final-approval');
        if(this._nceService.getNCEID().nce_record_id === ''){
            this._pageNavigationService.navigate(['home']);
            return;
        }
        this.loadNCE();
        this._nceService.resetError();
    }

    loadNCE() {
        this._nceService.loadDetailNCE(this._nceService.getNCEID().nce_record_id).then(
            (resolve) => {
                if(!(this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPLY_FINAL_APPROVAL || 
                    this.getDetailNCE().status_description === STATIC_VALUE.ALL_NCE_STATUS.APPLY_FINAL_APPROVAL_REJECTED)){
                    this._pageNavigationService.navigate(['home']);
                } else {
                    this._fileService.vFiles = this.getDetailNCE().attachment.finalApprovalApplication !== undefined ? this.getDetailNCE().attachment.finalApprovalApplication : [];
                    this._storageService.setSessionItem('nceFiles', JSON.stringify(this._fileService.getFileLists()));
                    let d = new Date(this.getDetailNCE().apply_for_final_approval_dates_1_date);
                    this.dates[1].date = ("" + (d.getMonth() + 1)).slice(-2) + '/' + ("" + d.getDate()).slice(-2) + '/' + d.getFullYear()
                }
            }, 
            (reject) => {
                this.openRetryPopup();
            }
        )
    }

    openRetryPopup(){
        this._popupService.closePopup();
        this._popupService.openPopup( 'confirmation', {
            title: 'Notice',
            message: 'Sorry, something went wrong',
            buttons: {
                CANCEL: {
                    text: 'Retry',
                    function: () => {
                        this._popupService.closePopup();
                        this.loadNCE();
                    }
                }
            }
        });
    }

    openStatusConfirmationPopup(pStatus: string, pAttachType: string, pMessage: string){
        this._popupService.openPopup( 'confirmation', {
            title: 'Notice',
            message: 'Are you sure?',
            buttons: {
                CANCEL: {
                    text: 'No',
                    function: () => {
                        this._popupService.closeConfirmationPopup();
                    }
                },
                OK: {
                    text: 'Yes',
                    function: () => {
                        if(this.isDisableSubmit()) {
                            this._popupService.openGeneralConfirmationPopup('Notice', 'Error submitting, please try again', '', false, false);
                        } else {
                            this.insertAppl().then(
                                response => {
                                    this.updateStatus(pStatus, pAttachType, pMessage);
                                }, error => {
                                    this._popupService.openGeneralConfirmationPopup('Notice', 'Error submitting, please try again', '', false, false);
                                }
                            );
                        }
                        this._popupService.closeConfirmationPopup();
                    }
                }
            }}
        );
    }

    updateStatus(pStatus, pAttachType, pMessage){
        this._nceService.updateStatus(this._nceService.getNCEID().nce_record_id, pStatus).then(
            (resolve) => {
                // this._fileService.getSignedRequest(this.file, 'nce', pAttachType, this._nceService.getNCEID().nce_request_id, this._nceService.getNCEID().nce_record_id);
                this._layoutService.setNCEFlow('nce-apply-for-final-approval');
                this._popupService.openLinkConfirmationPopup('Notice', 'Application for Final Approval has been successfully submitted', '', true, false, 'Close', 'nce-application/view/'+this._nceService.getNCEID().nce_record_id);
            },
            (reject) => {
                this._popupService.openGeneralConfirmationPopup('Notice', 'Error submitting, please try again', '', false, false);
            }
        );
    }

    insertAppl() {
        return new Promise((resolve, reject) => {
            this._nceService.insertApplicationForFinalApproval(this._nceService.getNCEID().nce_record_id, this.getAppl()).then(
                (response) => {
                    this._layoutService.setNCEFlow('nce-apply-for-final-approval');
                    this._storageService.removeSessionItem('nceFiles');
                    this._storageService.removeSessionItem('nceMultipleFiles');
                    this._storageService.removeSessionItem('nceNewMultipleFiles');
                    this._nceService.resetUploadDocumentData();
                    resolve();
                },
                (error) => {                 
                    reject();
                }
            );
        })
    }

    getAppl() {
        let dateArray:any = [{}];
        let datesClone:any = this.dates.slice();
        let d1 = new Date(this.getDetailNCE().apply_for_final_approval_dates_1_date);                    
        dateArray.push({
            completed: datesClone[1].completed, 
            date: (d1 ? d1.getFullYear() + '-' + ("0" + (d1.getMonth() + 1)).slice(-2) + '-' + ("0" + d1.getDate()).slice(-2) : null)
        });
        for(let i = 2; i < datesClone.length; i++) {
            let d : any = new Date(datesClone[i].date);
            let stringDate : any = d ? d.getFullYear() + '-' + ("0" + (d.getMonth() + 1)).slice(-2) + '-' + ("0" + d.getDate()).slice(-2) : null;
            dateArray.push({
                completed: datesClone[i].completed, 
                date: stringDate
            });
        }
        return {
            bottom_contractor_name : this.bottom_contractor_name,
            bottom_contractor_designation : this.bottom_contractor_designation,
            details : this.details,
            dates : dateArray
        };
    }

    getAllNCEStatus(){
        return STATIC_VALUE.ALL_NCE_STATUS;
    }

    goBack(){
        this._location.back();
    }

    isLoading(){
        if(this._nceService.isLoading() == true || this._fileService.isLoading() == true)
            return true;
        else
            return false;
    }

    isAbleDeleteFile() {
        return this.file ? true : false;
    }

    deleteFile() {
        this._fileService.deleteFiles(this._nceService.getNCEID().nce_request_id, 'nce', 'finalApprovalApplication' , this.file.name).then(
            (resolve) => {
                this.file = null;
            },
            (reject) => {
                this._popupService.openGeneralConfirmationPopup('Error', 'Delete file unsuccessful, please try again', '', false, false);
            }
        );
    }

    fileEvent(fileInput) {
        let tempFile = fileInput.target.files[0];
        if(tempFile.size > CONFIGURATION.FILE.MAX_SIZE || (tempFile.type !== "image/jpeg" && tempFile.type !== "application/pdf")) {
            this._popupService.openGeneralConfirmationPopup('Error', 'Attached file type must be PDF or JPEG file only and up to 10MB', '', false, false);
        }
        else if(this.file !== undefined && this.file !== '' && this.file !== null ){
            let prevFile = this.file;
            this._fileService.deleteFiles(this._nceService.getNCEID().nce_request_id, 'nce', 'finalApprovalApplication' , prevFile.name).then(
                (resolve) => {
                    this._fileService.getSignedRequest(tempFile, 'nce', 'finalApprovalApplication', this._nceService.getNCEID().nce_request_id, this._nceService.getNCEID().nce_record_id);
                    this.file = tempFile;
                },
                (reject) => {
                    this._popupService.openGeneralConfirmationPopup('Error', 'Upload unsuccessful, please try again', '', false, false);
                    this.file = prevFile;
                }
            );
        } else {
            this._fileService.getSignedRequest(tempFile, 'nce', 'finalApprovalApplication', this._nceService.getNCEID().nce_request_id, this._nceService.getNCEID().nce_record_id);
            this.file = tempFile;
        }
    }

    isDisableSubmit(){
        let isValid = true;
        
        if(!this.getAppl().bottom_contractor_designation || !this.getAppl().bottom_contractor_name)
            isValid = false;

        let trimmedDetails = this.getAppl().details.trim();
        if(!trimmedDetails || trimmedDetails.length <= 0)
            isValid = false;

        let dates : any = this.getAppl().dates;
        for(let i = 1; i < dates.length; i++) {
            if(!dates[i].completed || !dates[i].date) {
                isValid = false;
            }
        }
        console.log(this.getAppl())
        return !isValid;
    }

    getDetailNCE(){
        return this._nceService.getDetailNCE();
    }

    getFileList(){
        return this._fileService.getFileLists();
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce/components/apply-for-final-approval.component.ts